export const purchaseRoutes = [
  {
    path: '/purchase/supplier-manager',
    component: () => import('@/views/modules/purchase/supplier/supplier-manager'),
    meta: { name: '供应商资料', keepAlive: true, permission: 'supplier:view' ,modal:'采购' }
  },
  {
    path: '/purchase/purchase-order',
    component: () => import('@/views/modules/purchase/purchase-order/purchase-order'),
    meta: { name: '采购订单', keepAlive: true, permission: 'purchaseOrder:view' ,modal:'采购'}
  },
  {
    path: '/purchase/purchase-order-change',
    component: () => import('@/views/modules/purchase/purchase-order-change/purchase-order-change'),
    meta: { name: '采购变更单', keepAlive: true, permission: 'purchaseOrderChange:view' ,modal:'采购'}
  },
  {
    path: '/purchase/delivery-order',
    component: () => import('@/views/modules/purchase/delivery-order/delivery-order'),
    meta: { name: '交货单', keepAlive: true, permission: 'purchaseDeliveryNote:view',modal:'采购' }
  },
  {
    path: '/purchase/purchase-plan',
    component: () => import('@/views/modules/purchase/purchase-plan/purchase-plan'),
    meta: { name: '采购计划', keepAlive: true, permission: 'purchasePlan:view' ,modal:'采购'},
  }
];
